import { createFormHook } from '@tanstack/react-form';
import { fieldContext, formContext } from './contexts';
import { Checkbox } from '@/components/form/Checkbox';
import { FileInput } from '@/components/form/FileInput';
import { RadioGroup } from '@/components/form/RadioGroup';
import { SelectField } from '@/components/form/SelectField';
import { TextareaField } from '@/components/form/TextareaField';
import { TextField } from '@/components/form/TextField';
import { ZipCityField } from '@/components/form/ZipCityField';

export const { useAppForm } = createFormHook({
  fieldComponents: {
    TextField,
    TextareaField,
    RadioGroup,
    Checkbox,
    FileInput,
    SelectField,
    ZipCityField,
  },
  formComponents: {},
  fieldContext,
  formContext,
});
